import React from "react";

export const interactiveTextLinkClasses =
    "text-gray-500 hover:text-gray-700 hover:underline cursor-pointer rounded " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 " +
    "disabled:text-gray-300 disabled:no-underline disabled:cursor-default";

const InteractiveTextLink = React.forwardRef<
    HTMLButtonElement,
    React.ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
    const { className, type, ...rest } = props;
    const extendedClassName = `${className ?? ""} ${interactiveTextLinkClasses}`;
    return (
        <button
            ref={ref}
            type={type ?? "button"}
            className={extendedClassName}
            {...rest}
        />
    );
});

InteractiveTextLink.displayName = "InteractiveTextLink";
export { InteractiveTextLink };
